<template>
    <div>
        <ContentHeader path-set-type="append"   />
        <div class="content-wrapper" v-loading="loading" >
            <el-row>
                <el-col class="content-right" >
                    <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <el-form-item class="item selcetItem" style="width:140px" prop="themeId">
                            <el-select v-model="searchForm.themeId" :popper-append-to-body="false" placeholder="选择活动主题" filterable clearable  size="small">
                                <el-option
                                v-for="item in themeList"
                                :key="item.themeId"
                                :label="item.themeName"
                                :value="item.themeId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item class="item" prop="blockName">
                        <el-input
                            v-model="searchForm.blockName"
                            placeholder="街区名称"
                            size="small"
                            clearable
                        ></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="pocName">
                        <el-input
                            v-model="searchForm.pocName"
                            placeholder="门店名称"
                            size="small"
                            clearable
                        ></el-input>
                        </el-form-item> -->
                        <el-form-item class="item" prop="selectChannel">
                            <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" size="small" clearable>
                                <el-option
                                v-for="item in channelOptions"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="selectType">
                        <el-select v-model="searchForm.selectType" placeholder="选择形式" size="small" filterable clearable>
                            <el-option
                            v-for="(key,value) in typeOptions"
                            :key="value"
                            :label="key"
                            :value="value">
                            </el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item class="item" style="margin-right: 12px;" prop="selectLevel">
                        <el-select v-model="searchForm.selectLevel" placeholder="选择级别" size="small" filterable clearable>
                            <el-option
                            v-for="(key,value) in levelOptions"
                            :key="value"
                            :label="key"
                            :value="value">
                            </el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="buCode">
                            <el-select v-model="searchForm.buCode" placeholder="选择BU" filterable  size="small" clearable @change="cahngeBu()">
                                <el-option
                                v-for="item in buArr"
                                :key="item.orgCode"
                                :label="item.orgName"
                                :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" style="width:150px" prop="regionCode">
                            <el-select v-model="searchForm.regionCode" placeholder="选择销售大区" filterable  size="small" clearable>
                                <el-option
                                v-for="item in regionArr"
                                :key="item.orgCode"
                                :label="item.orgName"
                                :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="submitForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                    <div class="item-select" v-if="cardData.length > 0">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                        <div class="select-btn">
                            <DialogPop
                            @confirm="sendBackall"
                            @getRejectaccount="getRejectaccount"
                            :marLeft="true"
                            :isReject="true"
                            isType="1"
                            btnText="批量退回"
                            centerText="是否确认批量退回？"
                            ></DialogPop>
                            <DialogPop
                            @confirm="passThroughall"
                            isType="0"
                            :marLeft="true"
                            btnText="批量通过"
                            centerText="是否确认批量通过？"
                            >
                            </DialogPop>
                            <!-- <DialogPop
                            @confirm="getAllthemelist"
                            isType="0"
                            btnText="全部通过"
                            centerText="是否确认全部通过？"
                            ></DialogPop> -->
                        </div>
                    </div>
                    <div v-if="cardData.length > 0" >
                        <div class="card-box" v-for="(item) in cardData" :key="item.activityId" >
                            <div class="card-left"  >
                            <div class="left-select">
                                <el-checkbox v-model="item.isChecked" @change="changeItem(item.isChecked,item)"></el-checkbox>
                            </div>
                            </div>
                            <div class="card-right card-item is-hover-shadow">
                            <div class="left">
                                <div class="left-top">
                                <div class="top-name">
                                    <span v-if="item.blockName">{{item.blockName}}</span>
                                    <span v-else>{{item.gpActivityPocDTOList[0].pocName}}</span>
                                    <span style="margin-left: 5px;" v-if="item.blockName && item.gpActivityPocDTOList">：
                                        <span>{{getToolsname(item,'saleName','、')}}</span>
                                    </span>
                                </div>
                                <div class="top-sign" v-if="item.themeInfoDTO">{{getBluename(item.themeInfoDTO.orgLevel)}}</div>
                                </div>
                                <div class="left-second">
                                <div class="second-left">{{getToolsname(item,'activityName','-')}}</div>
                                    <div  class="second-right">
                                        <span class="font-weight-bold">活动时间：</span>
                                        <span>{{ getTime(item.themeInfoDTO.themeStartTime) }}</span>
                                        <span>-</span>
                                        <span>{{ getTime(item.themeInfoDTO.themeEndTime) }}</span>
                                </div>
                                </div>
                                <div class="left-third">
                                <span class="font-weight-bold">活动执行日期：</span>
                                <span>{{ getToolsname(item,'timeName',' | ') }}</span>
                                </div>
                                <div class="left-second">
                                <div class="second-left">
                                    <span class="font-weight-bold">区域：</span>
                                    <span>{{getToolsname(item,'areaName','-')}}</span>
                                </div>
                                <div class="second-right">
                                    <span class="font-weight-bold">提报要求售点：</span>
                                    <span>{{getToolsname(item,'typeName','-')}}</span>
                                </div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="right-top">待审批</div>
                                <div class="right-center"></div>
                                <div class="right-btn" >
                                <div class="btn-right" @click="goApproval(item)">
                                    去审批
                                </div>
                                <!-- <div class="btn-right2" v-else @click="goApproval(item)">
                                    查看详情
                                </div> -->
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <!-- {{loadingText}}
                        style="height:50vh; line-height:50vh;text-align: center;" -->
                        <el-empty description="暂无数据"></el-empty>

                    </div>
                    <div class="pagination" v-if="cardData.length > 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    import DialogPop from './components/dialog-pop.vue'
    export default {
      name: 'submit-approval',
      components: {
        ContentHeader,
        DialogPop
      },
      data () {
        return {
            searchForm: {
                themeId: '',
                blockName: '', // 街区名称
                pocName: '', // 门店名称
                selectChannel: '', // 选择渠道
                searchStatus: '',// 查询状态
                selectType: '', //形式
                selectLevel: '', //级别
                page: 1,
                pageSize: 10,
                total: 0,
                buCode: '',
                regionCode: '',
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            cardData: [],
            isFinish: false,
            isWait: false,
            loading:true,
            loadingText:'',
            menuCode: '',
            menuMap:[
                {key:'01',value:"待审批"},
                {key:'02',value:"已通过"}
            ],
            typeOptions: [],
            levelOptions: [],
            themeList: [],
            buArr:[],
            regionArr: [],
            rejectAccount: '',
            checkAll: false,
            isIndeterminate: false,
            selectList:[],
            allDatalist:[],
            allApprovelist:[],
            allApprovelist: false
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
        'searchForm.selectChannel': {
            handler (to, from) {
                this.getStyleMap()
                this.searchForm.selectType = ''
                this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
        },
        'searchForm.selectType': {
        handler (to, from) {
            this.getLevelMap()
            this.searchForm.selectLevel = ''
        },
        deep:true,
        immediate:true
        },
        // 'selectList': {
        // handler (to, from) {
        //     console.log(to,'tototototo');
        // },
        // deep:true,
        // immediate:true
        // },
      },
      created () {
        // this.menuCode = "01";
        this.init()
      },
      mounted () {},
      methods: {
        getChannel(themeChannels, sign) {
            if (themeChannels) {
                let arr = themeChannels.map((item) => {return item.themeChannelEnName}).join(sign);
                return arr;
            } else {
                return 'null'
            }
        },
        init () {
            this.getBuList()
            this.getSelectChannel()
            this.getThemeNamelist()
            this.getThemelist()
        },
        // 全部通过
        allApprovego () {
           let ThemeInfoVO = {
            activityInfoVOList:[]
            }
            if (this.allApprovelist.length == 0) {
                return this.$message.warning('当前条件下没有待审批的数据')
            }
            let testDatalist = this.allApprovelist
            let arr = []
            for (let item of testDatalist) {
                arr.push(
                    {gpActivityInfoDTO:{
                    processType:'02',
                    processAction:'02',
                    activityId:item.activityId,
                }})
            }
            ThemeInfoVO.activityInfoVOList = arr
            // console.log(ThemeInfoVO,'ThemeInfoVO-全部审批');
            this.isAllapprove = true
            this.gamepalnActivityapprove(ThemeInfoVO)
        },
        // 批量通过
        passThroughall () {
           let ThemeInfoVO = {
            activityInfoVOList:[]
            }
            let testDatalist = []
            for (const item1 of this.cardData) {
                if (item1.isChecked) {
                    testDatalist.push(item1)
                }

            }
            if (testDatalist.length == 0) {
                this.$message.warning('未选择售点')
            } else {
                let arr = []
                for (let item of testDatalist) {
                    arr.push(
                        {gpActivityInfoDTO:{
                        processType:'02',
                        processAction:'02',
                        activityId:item.activityId,
                    }})
                }
                ThemeInfoVO.activityInfoVOList = arr
                // console.log(ThemeInfoVO,'ThemeInfoVO-全部通过');
                this.gamepalnActivityapprove(ThemeInfoVO)
            }
        },
        // 批量退回
        sendBackall () {
            let ThemeInfoVO = {
                activityInfoVOList:[]
            }
            let testDatalist = []
            for (const item1 of this.cardData) {
                if (item1.isChecked) {
                    testDatalist.push(item1)
                }
            }
            if (testDatalist.length == 0) {
                this.$message.warning('未选择售点')
            } else {
                let arr = []
                for (const item of testDatalist) {
                    let gpActivityPocDTOList = []
                    if (item.gpActivityPocDTOList !== null) {
                        for (let item2 of item.gpActivityPocDTOList) {
                            gpActivityPocDTOList.push({
                                activityPocId:item2.activityPocId,
                                rejectStatus:item2.rejectStatus,
                                rejectReason:item2.rejectReason,
                            })
                        }
                    }
                    arr.push(
                        {
                            'gpActivityInfoDTO':
                            {
                                processType:'02',
                                processAction:'03',
                                activityId:item.activityId,
                                submitRejectReason:this.rejectAccount,
                                submitRejectPerson:this.userInfo.clientName,
                            },
                            'gpActivityPocDTOList':gpActivityPocDTOList
                        }
                    )

                }
                ThemeInfoVO.activityInfoVOList = arr
                // console.log(ThemeInfoVO,'ThemeInfoVO-全部退回');
                this.gamepalnActivityapprove(ThemeInfoVO)
            }
        },
        gamepalnActivityapprove (params) {
            this.loading = true
            gameplanApi.getGamepalnActivityapprove(params).then(res=>{
                if (res.data.resultCode === '0') {
                    if (this.isAllapprove) {
                        this.$message.success('全部通过成功');
                    } else {
                        if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '02') {
                            this.$message.success('批量通过成功');
                        } else if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '03') {
                            this.$message.success('批量退回成功');
                        }
                    }
                    this.$router.go(0)
                    this.isAllapprove = false
                    this.rejectAccount = ''
                    this.loading = false
                } else {
                    console.log('error');
                    this.loading = false
                }
            })
        },
        getToolsname (item,type,sign) {
        if (type == 'saleName') {
            let arr = item.gpActivityPocDTOList
            if (arr.length > 0) {
                let name = arr.map((item)=>{
                    return item.pocName
                }).join(sign)
                return name
            }
        } else if (type == 'activityName') {
            let arr = []
            if (item.themeInfoDTO.themeName) {
                arr.push(item.themeInfoDTO.themeName)
            }
            if (item.gpThemeDetailDTO.themeChannelName) {
                arr.push(item.gpThemeDetailDTO.themeChannelName.split('|')[1])
            }
            if (item.gpThemeDetailDTO.themeStyleName) {
                arr.push(item.gpThemeDetailDTO.themeStyleName)
            }
            if (item.gpThemeDetailDTO.themeLevelName) {
                arr.push(item.gpThemeDetailDTO.themeLevelName)
            }
            let name = arr.map((item)=>{
                return item
            }).join(sign)
            return name
        } else if (type == 'typeName') {
            if (!item.gpThemeDetailDTO) {
            return 'error'
            }
            let pocRelateType = item.gpThemeDetailDTO.pocRelateType
            if (pocRelateType == '0') {
                return '无售点'
            }else if (pocRelateType == '1') {
                return '单售点'
            } else if (pocRelateType == '2') {
                return '多售点'
            } else {
                return 'error'
            }
        } else if (type == 'timeName') {
            let arr = item.gpActivityTimeDTOList || []
            if (arr.length > 0) {
                let name = arr.map((item)=> {
                return item.activityTime
                }).join(sign)
                return name
            }else {
                return 'null'
            }
        } else if (type == 'areaName') {
            let arr = []
            if (item.buName) {
                arr.push(item.buName.split('|')[0])
            }
            if (item.regionName) {
                arr.push(item.regionName.split('|')[0])
            }
            let name = arr.map((item)=>{
                return item
            }).join(sign)
            return name
        } else {
            return 'error'
        }
        },
        getBluename (name) {
        if (name == 'region') {
            return 'Region'
        } else if (name == 'bu') {
            return 'BU'
        } else if (name == 'hq') {
            return 'HQ'
        } else {
            return 'error'
        }
        },
        cahngeBu () {
            if (!this.searchForm.buCode) {
                 return this.searchForm.regionCode = ''
            }
            if (this.buArr.length > 0) {
                for (const item of this.buArr) {
                    if (item.orgCode == this.searchForm.buCode) {
                        this.searchForm.buOrgId = item.orgId
                        this.getRegionList()
                    }
                }
            }
        },
        async getBuList () {
            let params = {}
            const { data } = await gameplanApi.getBuList(params);
            if (data.resultCode === "0") {
                this.buArr = data.resultData.buList || [];
                this.cahngeBu()
            }
        },
        async getRegionList () {
            if (!this.searchForm.buOrgId) {
                return
            }
            let params = {
                buOrgId: this.searchForm.buOrgId
            }
            const { data } = await gameplanApi.getRegionList(params);
            if (data.resultCode === "0") {
                this.regionArr = data.resultData.regionList || [];
            }
        },
        async getStyleMap () {
        let params = {
            channelCode:this.searchForm.selectChannel
        }
        const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
        if (data.resultCode === "0") {
            this.typeOptions = data.resultData.themeStyleMap || {};
        }
        },
        async getLevelMap () {
        let params = {
            styleCode:this.searchForm.selectType
        }
        const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
        if (data.resultCode === "0") {
            this.levelOptions = data.resultData.themeLevelMap || {};
        }
        },
        //单选
        changeItem (item,row) {
        // console.log(item,row,'单选');
        // isShowsome 未全选  isShowall 全选  isShownone 全不选
        // if (item) {
        //     if (!this.selectList.some((item) =>{item.activityId == row.activityId})) {
        //         this.selectList.push(row)
        //     }
        //     for (let i = 0; i < this.selectList.length; i++) {
        //         for (let j = i+1; j < this.selectList.length; j++) {
        //             if (this.selectList[i].activityId == this.selectList[j].activityId) {
        //                 this.selectList.splice(j,1)
        //                 j--
        //             }
        //         }
        //     }

        // } else {
        //     for (let j = 0; j < this.selectList.length; j++) {
        //         if (this.selectList[j].activityId == row.activityId) {
        //             this.selectList.splice(j,1)
        //             j--
        //         }
        //     }
        // }
        let isShowsome =  this.cardData.some(item=>{
            return item.isChecked == false
        })
        let isShowall =  this.cardData.every(item=>{
            return item.isChecked == true
        })
        let isShownone =  this.cardData.every(item=>{
            return item.isChecked == false
        })
        if (isShowall) {
            this.isIndeterminate = false
            this.checkAll = true
        } else if(isShownone) {
            this.isIndeterminate = false
            this.checkAll = false
        } else if(isShowsome) {
            this.isIndeterminate = true
            this.checkAll = false
        }
        },
        //全选
        handleCheckAllChange () {
        // isHavefasle 判断是否有至少一个勾选 isShowsome 未全选  isShowall 全选  isShownone 全不选
        let isHavefasle =  this.cardData.some(item=>{
            return item.isChecked == false
        })
        // console.log(isHavefasle,'isHavefasle');
        if (isHavefasle) {
            for (let item of this.cardData) {
                item.isChecked = true
            }
            // for (let i = 0; i < this.cardData.length; i++) {
            //     if (!this.selectList.some((item) =>{item.activityId == this.cardData[i].activityId})) {
            //         this.selectList.push(this.cardData[i])
            //     }
            // }
            // for (let i = 0; i < this.selectList.length; i++) {
            //     for (let j = i+1; j < this.selectList.length; j++) {
            //         if (this.selectList[i].activityId == this.selectList[j].activityId) {
            //             this.selectList.splice(j,1)
            //             j--
            //         }
            //     }
            // }
        } else {
            for (let item of this.cardData) {
                item.isChecked = !item.isChecked
            }
            // for (let i = 0; i < this.cardData.length; i++) {
            //     for (let j = 0; j < this.selectList.length; j++) {
            //         if (this.selectList[j].activityId ==  this.cardData[i].activityId ) {
            //             this.selectList.splice(j,1)
            //             j--
            //         }
            //     }
            // }
        }
        let isShowsome =  this.cardData.some(item=>{
            return item.isChecked == false
        })
        let isShowall =  this.cardData.every(item=>{
            return item.isChecked == true
        })
        let isShownone =  this.cardData.every(item=>{
            return item.isChecked == false
        })
        if (isShowall) {
            this.isIndeterminate = false
            this.checkAll = true
        } else if(isShownone) {
            this.isIndeterminate = false
            this.checkAll = false
        } else if(isShowsome) {
            this.isIndeterminate = true
            this.checkAll = false
        }
        },
        // 理由
        getRejectaccount (val) {
        this.rejectAccount = val
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        getThemeNamelist () {
            let params = {
                buCode:this.searchForm.buCode,
                regionCode:this.searchForm.regionCode,
                queryStatus:'01'
            }
            gameplanApi.getApprovenameList(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.themeList = res.data.resultData.themeNameList || []
                }
            })

        },
        getThemelist () {
            let params = {
                page: this.searchForm.page,
                pageSize: this.searchForm.pageSize,
                themeId:this.searchForm.themeId,
                themeChannelCode:this.searchForm.selectChannel,
                themeStyleCode:this.searchForm.selectType,
                themeLevelCode:this.searchForm.selectLevel,
                blockName:this.searchForm.blockName,
                pocName:this.searchForm.pocName,
                buCode:this.searchForm.buCode,
                regionCode:this.searchForm.regionCode,
                queryStatus:'01'
            }
            this.loading = true
            gameplanApi.getThemeApproveList(params).then(res=>{
                if (res.data.resultCode === '0') {
                    let pageData = res.data.resultData.pageInfo
                    this.searchForm.page = Number(pageData.curPage)
                    // this.searchForm.pageSize = pageData.totalPages
                    this.searchForm.total = Number(pageData.totalCounts)
                    // this.themeList = res.data.resultData.themeNameList || []
                    if (res.data.resultData.activityList == null) {
                        this.cardData = []
                        this.loadingText = '空数据'

                    } else {
                        let cardData = res.data.resultData.activityList;
                        for (let item of cardData) {
                        item.isChecked = false
                        }
                        this.cardData = cardData
                        this.isIndeterminate = false
                        this.checkAll = false
                        this.loadingText = "";
                        // let arr = JSON.parse(JSON.stringify(cardData))
                        // let allDatalist = this.allDatalist.concat(arr)
                        // for (let i = 0; i < allDatalist.length; i++) {
                        //     for (let j = i+1; j < allDatalist.length; j++) {
                        //         if (allDatalist[i].activityId == allDatalist[j].activityId) {
                        //             allDatalist.splice(j,1)
                        //             j--
                        //         }
                        //     }
                        // }
                        // this.allDatalist = allDatalist
                        // console.log(this.cardData,'cardData');
                        // console.log(this.allDatalist,'allDatalist');
                    }
                    this.loading = false
                } else {
                    this.loading = false
                    console.log('接口error');
                }
            })
        },
        getAllthemelist () {
            let params = {
                themeId:this.searchForm.themeId,
                themeChannelCode:this.searchForm.selectChannel,
                themeStyleCode:this.searchForm.selectType,
                themeLevelCode:this.searchForm.selectLevel,
                blockName:this.searchForm.blockName,
                pocName:this.searchForm.pocName,
                buCode:this.searchForm.buCode,
                regionCode:this.searchForm.regionCode,
                queryStatus:'01'
            }
            gameplanApi.getApprovenameList(params).then(res=>{
                if (res.data.resultCode === '0') {
                    if (res.data.resultData.activityList == null) {
                        this.allApprovelist = []
                    } else {
                        this.allApprovelist = res.data.resultData.activityList
                    }
                    this.allApprovego()
                }
            })
        },
        async getSelectChannel () {
            // name=gpThemeChannelMap&type=list或map
            let params = {
                name:'gpThemeChannelMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.channelOptions = data.data.resultData.gpThemeChannelMap
        },
        handleCurrentChange (val) {
          this.searchForm.page = val
          this.getThemelist()
        },
        submitForm (val) {
            this.$refs.searchForm.validate((valid) => {
            if (valid) {
                this.searchForm.page = 1
                this.getThemelist()

            } else {
                return false;
            }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.getThemelist()
        },
        // 去审批
        goApproval (item) {
            this.$router.push({path:'/gameplan/submit-approval-detail',query: { 'themeId':item.themeId,'activityId':item.activityId,'themeDetailId':item.themeDetailId}})
        },
        // 已通过详情
        goDetail(item) {
            this.$router.push({path:'/gameplan/submit-approval-detail-two',query: { 'themeId':item.themeId,'themeStatus':item.themeStatus,'routerType': this.searchForm.searchStatus}})
        },
      }
    }
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            .searchForm {
                width: 1000px;
                // margin: auto;
                margin-left: 30px;
                .item {
                    width:120px;
                    ::v-deep .el-input__inner {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                .item-btn {
                    margin-left: 30px;
                }
                .selcetItem{
                    ::v-deep .el-select-dropdown__wrap {
                        max-height: 274px;
                        max-width: 200px;
                    }
                }
            }
        }
        .item-select {
          line-height: 30px;
          height: 30px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
              color: #cd1231;
          }
          .select-btn {
              display: flex;
              justify-content: flex-end;
              margin: auto;
              margin-right: 10px;
          }
        }
        .card-box {
            border-radius: 10px;
            margin-bottom: 30px;
            font-size: 14px;
            text-align: left;
            color: #101010;
            display: flex;
            .card-left {
                display: flex;
                flex-flow: column;
                justify-content: center;
                width: 40px;
                .left-select {
                    margin-right: 15px;
                }
            }
            .card-right {
                flex: 1;
                display: flex;
                .left {
                    text-align: left;
                    color: #101010;
                    width: 90%;
                    .left-top {
                        // line-height: 27px;
                        // font-family: SourceHanSansSC-medium;
                        // font-size: 18px;
                        // font-weight: 600;
                        // word-wrap: break-word;
                        // word-break: normal;
                        // word-break: break-all;
                        padding-bottom: 10px;
                        font-size: 18px;
                        display: flex;
                        .top-name {
                            font-weight: 600;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                        .top-sign {
                            color: #FFFFFF;
                            background-color: #40A5EE;
                            margin-left: 10px;
                            padding: 0px 8px;
                            line-height: 18px;
                            height: 18px;
                            font-size: 14px;
                            margin-top: 2px;
                            font-weight: 600;
                        }
                    }
                    .left-second {
                        font-size: 14px;
                        display: flex;
                        padding-bottom: 5px;
                        padding-top: 5px;
                        .second-left {
                            margin-right: 25px;
                            line-height: 20px;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                        .second-right {
                            flex: 1;
                            min-width: 100px;
                            line-height: 20px;
                        }
                    }
                    .left-third {
                        font-size: 14px;
                        line-height: 20px;
                        padding-bottom: 5px;
                        padding-top: 5px;
                    }
                }
                .right {
                    flex: 1;
                    text-align: right;
                    .right-top {
                        line-height: 27px;
                        color: #CD1231 ;
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .right-center {
                        margin-top: 26px;
                        height: 20px;
                        line-height: 20px;
                    }
                    .right-btn {
                        margin-top: 6px;
                        display: flex;
                        justify-content: flex-end;
                        font-size: 12px;
                        text-align: center;
                        height: 30px;
                        line-height: 30px;
                        .btn-right {
                            border: 0px solid #CD1231;
                            width: 80px;
                            border-radius: 4px;
                            background-color: #cd1231;
                            color: #ffffff;
                            cursor: pointer;
                        }
                        .btn-right2 {
                            border: 1px solid #CD1231;
                            width: 80px;
                            border-radius: 4px;
                            background-color: #ffffff;
                            color: #CD1231;
                            cursor: pointer;
                        }
                    }
                }
            }
            .card-item{
                background-color: #FFFFFF;
                border-radius: 10px;
                padding: 10px 20px;
                font-size: 14px;
                text-align: left;
                color: #101010;
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
    }
    </style>
<style>
.pagination .el-pagination {
    text-align: center;
}
</style>
